module.exports = __webpack_public_path__ + "img/pro_three.7c285fdb.jpg";